/**
 * Design System - Shadow Tokens
 *
 * Box shadow definitions from Figma design
 */

export const shadows = {
  // Elevation shadows
  none: 'none',
  xs: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
  sm: '0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)',
  md: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1)',
  lg: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1)',
  xl: '0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 8px 10px -6px rgba(0, 0, 0, 0.1)',
  '2xl': '0px 25px 50px -12px rgba(0, 0, 0, 0.25)',

  // Component-specific shadows from design
  card: '4px 4px 4px 0px rgba(0, 0, 0, 0.1)',
  button: 'none',
  dropdown: '0px 4px 16px 0px rgba(0, 0, 0, 0.1)',
  modal:
    '0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 8px 10px -6px rgba(0, 0, 0, 0.1)',

  // Inner shadows
  inner: {
    sm: 'inset 0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
    md: 'inset 0px 2px 4px 0px rgba(0, 0, 0, 0.06)',
  },

  // Colored shadows (for focus states)
  focus: {
    primary: '0 0 0 3px rgba(253, 224, 71, 0.5)', // Yellow focus
    error: '0 0 0 3px rgba(239, 68, 68, 0.5)', // Red focus
    success: '0 0 0 3px rgba(34, 197, 94, 0.5)', // Green focus
  },
} as const;

export type ShadowToken = typeof shadows;

// Component shadow presets
export const componentShadows = {
  card: {
    default: shadows.card,
    hover: shadows.md,
  },
  button: {
    default: shadows.none,
    hover: shadows.sm,
    active: shadows.inner.md,
  },
  input: {
    default: shadows.none,
    focus: shadows.focus.primary,
    error: shadows.focus.error,
  },
  dropdown: {
    default: shadows.dropdown,
  },
  modal: {
    default: shadows.modal,
  },
} as const;
